export const DATE_FORMATE_NB = "dd.MM.yyyy"
export const DATE_FORMATE_NB_SHORT = "dd.MM.yy"
export const DATE_FORMATE_NB_WITH_TIME = "dd.MM.yyyy HH:II"
export const DATE_FORMATE_MONTH_NB = "MM"
export const DATE_FORMATE_EN = "yyyy.MM.dd"
